import { render, staticRenderFns } from "./TheFilm.vue?vue&type=template&id=73ba4a24&"
import script from "./TheFilm.vue?vue&type=script&lang=js&"
export * from "./TheFilm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports